module.exports = __webpack_public_path__ + "static/late.d389fb56.svg";